module.exports = __webpack_public_path__ + "static/testimonialsEnglish-min-0e2382324ebe3e9d57b12c20f1da9ee9.png";